export const onUpdateExecution = `
    subscription onUpdateExecution($id: ID) {
        onUpdateExecution(id: $id) {
            id
            playbookId
            playbook {
                id
                name
                displayName
            }
            name
            description
            executionStatus
            sfnExecutionArn
            executionInput
            executionOutput
            currentPhase
            totalPhases
            completedPhases
            startedAt
            completedAt
            failedStepId
            failedStepName
            failureReason
            createdByUsername
            created
            updated
        }
    }
`;

export const onUpdateExecutionPhase = `
    subscription onUpdateExecutionPhase($executionId: ID) {
        onUpdateExecutionPhase(executionId: $executionId) {
            id
            executionId
            phaseId
            phaseName
            position
            phaseStatus
            startedAt
            completedAt
            created
            updated
        }
    }
`;

export const onUpdateExecutionStep = `
    subscription onUpdateExecutionStep($executionId: ID) {
        onUpdateExecutionStep(executionId: $executionId) {
            id
            executionId
            executionPhaseId
            stepId
            phaseId
            stepName
            taskStateName
            position
            stepStatus
            startedAt
            completedAt
            elapsedMs
            input
            output
            errorMessage
            errorType
            retryCount
            created
            updated
        }
    }
`;
